import {Node} from "@xyflow/react";
import {MemberType} from "../models/MemberType";
import {
    FAMILY_MEMBER_HEIGHT,
    NODE_WIDTH_DEFAULT,
    NODE_WIDTH_LONG,
    OTHER_MEMBERS_SECTION_HEIGHT_FALLBACK
} from "./FamilyTreeLayoutConstants";

export function getNodeWidthFromNames(firstName: string | undefined, lastName: string | undefined): number {
    const isLongName = (firstName?.length ?? 0) > 15 || (lastName?.length ?? 0) > 15;
    return isLongName ? NODE_WIDTH_LONG : NODE_WIDTH_DEFAULT;
}

function isNodeInput(input: MemberType | Node): input is Node {
    return 'position' in input || 'type' in input || 'data' in input;
}

export function getNodeDimensions(input: MemberType | Node): { width: number; height: number } {
    if (isNodeInput(input)) {
        const node = input;
        const data = node.data as { firstName?: string; lastName?: string } | undefined;
        const width = (typeof node.width === 'number' && node.width > 0)
            ? node.width
            : getNodeWidthFromNames(data?.firstName, data?.lastName);
        let height = FAMILY_MEMBER_HEIGHT;
        if (typeof node.height === 'number' && node.height > 0) {
            height = node.height;
        } else if (node.type === 'otherMembersSection') {
            height = OTHER_MEMBERS_SECTION_HEIGHT_FALLBACK;
        }
        return {width, height};
    }

    return {
        width: getNodeWidthFromNames(input.firstName, input.lastName),
        height: FAMILY_MEMBER_HEIGHT
    };
}

export function getNodeWidth(input: MemberType | Node): number {
    return getNodeDimensions(input).width;
}
